import { render, staticRenderFns } from "./MainOrganization.vue?vue&type=template&id=5f84268f&scoped=true&"
import script from "./MainOrganization.vue?vue&type=script&lang=js&"
export * from "./MainOrganization.vue?vue&type=script&lang=js&"
import style0 from "./MainOrganization.vue?vue&type=style&index=0&id=5f84268f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84268f",
  null
  
)

export default component.exports